// extracted by mini-css-extract-plugin
export default {"Banner":"Banner_Banner__cdxgh","overlay":"Banner_overlay__N91UT"};